import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { getTernaryLabel, getTernaryValue, labelToValue } from '@/utils/ternary-enum.ts';

interface MixedComboProps {
  label: string;
  id: string;
  name: string;
  optionValue: string;
  observationsValue?: string;
  onOptionChange: (field: string, textValue: string) => void;
  onObservationsChange: (selectedValue: string) => void;
}

const options = Object.keys(labelToValue);

const TernaryOptionSelect: React.FC<MixedComboProps> = ({
  label,
  id,
  name,
  optionValue,
  observationsValue,
  onOptionChange,
  onObservationsChange,
}) => {
  const handleObservationsChange: React.ChangeEventHandler<
    HTMLInputElement | HTMLTextAreaElement
  > = (event) => {
    const newValue = event.target.value;
    onObservationsChange(newValue);
  };

  const handleOptionChange = (_: React.SyntheticEvent, newLabel: string | null) => {
    const newValue = newLabel ? getTernaryValue(newLabel) : '';
    onOptionChange(name, newValue);
  };

  return (
    <div>
      <Autocomplete
        value={getTernaryLabel(optionValue)}
        id={'ac_' + id}
        options={options}
        onChange={handleOptionChange}
        isOptionEqualToValue={(option, value) => option === value || value === ''}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            name={name}
            id={id}
            value={optionValue}
          />
        )}
      />
      {optionValue === 'OTHER' && (
        <>
          <br />
          <TextField
            label={`Observaciones`}
            variant="outlined"
            name={'atf_' + name}
            id={'atf_' + id}
            value={observationsValue}
            onChange={handleObservationsChange}
          />
        </>
      )}
    </div>
  );
};

export default TernaryOptionSelect;
